var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import UploadFile from "@/components/dev/upload";
import { useCallback, useEffect, useState } from "react";
import { useSaveFaceliftMutation } from "@/store/api";
import { initials } from "@/utils/funcs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faTrash } from "@fortawesome/pro-regular-svg-icons";
/** <b>Composant d'affichage en mode édition d'un champ de type facelift</b>*/
export default function FaceliftFieldEdit(_a) {
    var _this = this;
    var moduleName = _a.moduleName, fieldName = _a.fieldName, record = _a.record, onUpdate = _a.onUpdate;
    var _b = useState(), file = _b[0], setFile = _b[1];
    var _c = useState(false), fileRemoved = _c[0], setFileRemoved = _c[1];
    var _d = useState(false), showUpload = _d[0], setShowUpload = _d[1];
    var _e = useState(null), uploadStatus = _e[0], setUploadStatus = _e[1];
    var _f = useState(""), labelUpload = _f[0], setLabelUpload = _f[1];
    var _g = useState(null), imgPreview = _g[0], setImgPreview = _g[1];
    var _h = useState(false), showActionBtn = _h[0], setShowActionBtn = _h[1];
    useEffect(function () {
        if (imgPreview === null || imgPreview === undefined) {
            setShowUpload(true);
        }
        else {
            setFileRemoved(true);
        }
        setLabelUpload("select image");
    }, [fileRemoved, imgPreview]);
    var removeFile = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            try {
                setImgPreview(null);
                setShowActionBtn(false);
                onUpdate && onUpdate((_a = {}, _a[fieldName] = "", _a));
            }
            catch (error) {
                console.log(error);
            }
            return [2 /*return*/];
        });
    }); };
    var saveFaceliftMutation = useSaveFaceliftMutation()[0];
    var saveFacelift = function () { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, saveFaceliftMutation({
                        moduleName: moduleName,
                        recordId: record.id,
                        body: {
                            file: file,
                            chunkNumber: 1,
                            totalChunks: 1,
                        },
                    })];
                case 1:
                    response = _a.sent();
                    setShowActionBtn(false);
                    if (response.payload === "ko") {
                        alert("Il y a une erreur lors de l'enregistrement du fichier.");
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onEntriesDroped = useCallback(function (acceptedFiles) {
        try {
            acceptedFiles.forEach(function (fileEntry) {
                var _a;
                var isValidType = ((_a = fileEntry === null || fileEntry === void 0 ? void 0 : fileEntry.type) === null || _a === void 0 ? void 0 : _a.startsWith("image/"))
                    ? true
                    : false;
                var file = fileEntry.file;
                if (!isValidType) {
                    setUploadStatus("Error: Invalid file type.");
                    return;
                }
                var reader = new FileReader();
                if (reader !== undefined) {
                }
                setFile(fileEntry);
                setUploadStatus("Uploading...");
                setImgPreview(URL.createObjectURL(file));
                setShowActionBtn(true);
                setUploadStatus("success");
                onUpdate && onUpdate(record);
            });
        }
        catch (error) {
            setUploadStatus("Error: Upload failed.");
        }
    }, [fileRemoved, imgPreview, onUpdate, record]);
    return (_jsxs("div", __assign({ className: "" }, { children: [showUpload && !imgPreview && (_jsx(UploadFile, { onEntriesDroped: onEntriesDroped, type: "image", labelUpload: labelUpload })), (uploadStatus === null || uploadStatus === void 0 ? void 0 : uploadStatus.includes("Error")) ? (_jsx("span", __assign({ className: "pl-2 text-red-500" }, { children: uploadStatus }))) : (""), imgPreview && fileRemoved ? (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "w-16 h-16 rounded-full overflow-hidden " }, { children: _jsx("img", { src: imgPreview, alt: record && initials(record), title: record && record.name, className: "object-cover w-full h-full" }) })), showActionBtn && (_jsxs("div", __assign({ className: "flex flex-row text-center" }, { children: [_jsx("span", __assign({ className: "w-1/2" }, { children: _jsx(FontAwesomeIcon, { icon: faUpload, size: "1x", className: "pt-3 text-blue-500 hover:cursor-pointer", onClick: saveFacelift }) })), _jsx("span", __assign({ className: "w-1/2" }, { children: _jsx(FontAwesomeIcon, { icon: faTrash, size: "1x", className: "pt-3 text-red-500 hover:cursor-pointer", onClick: removeFile }) }))] })))] })) : (_jsx(_Fragment, {}))] })));
}
